export const apiUrl = "https://sales-lentz-backend.azurewebsites.net";
// export const apiUrl = "http://DESKTOP-A2HHV4S:4000";
export const BaseUrl = (url) => `${apiUrl}/api/v1/${url}`;

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const recordLimit = 10;

export const apiKey = "AIzaSyBSzp2Q-i_VkdIHnxJSfGw8YYO3Gfp5zP8";
